// Angular
import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";

// Security
import { SignInComponent } from "app/_authentication/signin.component";
import { AuthGuard } from "./_authentication/auth.guard";
import { FUNCTIONALITIES } from "./_constants/functionalities";
import { ROLES } from "./_constants/roles";
import { AlphaGuard } from "./_guards/alpha.guard";

// Layouts
import { FullLayoutComponent } from './_layouts/full-layout.component';
import { SimpleLayoutComponent } from './_layouts/simple-layout.component';

export const routes: Routes = [
  {
    path: "",
    redirectTo: "pages/login",
    pathMatch: "full",
  },
  {
    path: "login",
    component: SignInComponent,
  },
  {
    path: "",
    component: FullLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: "Home",
    },
    children: [
      {
        path: "dashboard",
        loadChildren: () => import('app/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: {
          title: "Dashboard",
          breadcrumbs: "Dashboard",
        },
      },
      {
        path: "visits",
        loadChildren: () => import('app/visits/visits.module').then(m => m.VisitsModule),
        data: {
          title: "Visits",
          breadcrumbs: "Visits",
        },
      },
      {
        path: "case",
        loadChildren: () => import('app/case/case.module').then(m => m.CaseModule),
        data: {
          title: "Case",
          breadcrumbs: "Case",
        },
      },
      {
        path: "taskbasket",
        loadChildren: () => import('app/taskbasket/taskbasket.module').then(m => m.TaskBasketModule),
        data: {
          title: "Taskbasket",
          breadcrumbs: "Taskbasket",
        },
      },
      {
        path: "management",
        loadChildren: () => import('app/management/management.module').then(m => m.ManagementModule),
        canActivate: [AlphaGuard],
        data: {
          functionality: FUNCTIONALITIES.APPLICATION_MANAGEMENT
          }
      },
      {
        path: "dossier",
        loadChildren: () => import('app/dossier/dossier.module').then(m => m.DossierModule),
        data: {
          functionality: FUNCTIONALITIES.DOSSIER_MANAGEMENT
          }
      },
      {
        path: "draftDossier",
        loadChildren: () => import('app/draft-dossier/draft-dossier.module').then(m => m.DraftDossierModule),
        data: {
          functionality: FUNCTIONALITIES.INTAKE
        },
      },
      {
        path: "calamity",
        loadChildren: () => import('app/calamity/calamity.module').then(m => m.CalamityModule),
        data: {
          functionality: FUNCTIONALITIES.Calamities
          }
      },
      {
        path: "cz-expats",
        loadChildren: () => import('app/cz-expats/cz-expats.module').then(m => m.CzExpatsModule),
        data: {
          functionality: FUNCTIONALITIES.CZ_Expats
          }
      },
      {
        path: "support",
        loadChildren: () => import('app/support/support.module').then(m => m.SupportModule),
        data: {
          functionality: FUNCTIONALITIES.OU_MANAGEMENT
          }
      },
      {
        path: "network",
        loadChildren: () => import('app/network/supplier.module').then(m => m.SupplierModule),
        canActivate: [AlphaGuard],
        data: {
          functionality: FUNCTIONALITIES.SUPPLIERS_MANAGEMENT
          }
      },
      {
        path: "reports",
        loadChildren: () => import('app/reports/reports.module').then(m => m.ReportsModule),
        data: {
          functionality: FUNCTIONALITIES.Reports
          }
      }
    ],
  },
  {
    path: "pages",
    component: SimpleLayoutComponent,
    data: {
      title: "Pages",
    },
    children: [
      {
        path: "",
        loadChildren: () => import('app/_pages/pages.module').then(m => m.PagesModule),
      },
    ],
  },
  {
    path: "**",
    redirectTo: "",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true, enableTracing: false , preloadingStrategy: PreloadAllModules
  })],

  exports: [RouterModule],
  providers: [AlphaGuard],
})
export class AppRoutingModule { }
